/**
 * Decide si una búsqueda sin resultados debe registrarse como `search_no_result`.
 * Umbral mínimo de 3 caracteres (ignorando espacios) para evitar ruido de
 * términos a medio escribir; solo cuando NO hubo ningún resultado.
 */
export function shouldLogNoResult(query: string, resultCount: number): boolean {
  return query.trim().length >= 3 && resultCount === 0
}
